import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { HOURLY, DAILY, WEEKLY, MONTHLY } from '../../../models/resolution';

class GraphHeader extends Component {
  onResoulationChange(type) {
    var { name, resolution } = this.props;

    if (resolution !== type) {
      this.props.resolutionChange(type, name);
    }
  }
  render() {
    var { title, hasHourly, resolution, dayDiff } = this.props;
    var showHourly = hasHourly;
    var showDaily = (resolution !== HOURLY || dayDiff > 1) && dayDiff < 30 * 6;
    var showWeekly = resolution !== HOURLY && dayDiff > 7;
    var showMonthly = resolution !== HOURLY && dayDiff > 30;
    var resolutionBorderComponent = <span style={{ color: 'grey' }}> | </span>;

    var hourlyResolutionComponent;
    if (hasHourly) {
      let className = classnames('link', { selected: resolution === HOURLY });
      hourlyResolutionComponent = (
        <span className={className} onClick={this.onResoulationChange.bind(this, HOURLY)}>
          Hourly
        </span>
      );
    }
    if ((resolution !== HOURLY || dayDiff > 1) && dayDiff < 30 * 6) {
      let className = classnames('link', { selected: resolution === DAILY });
      var dailyResolutionComponent = (
        <span className={className} onClick={this.onResoulationChange.bind(this, DAILY)}>
          Day
        </span>
      );
    }

    var weeklyResolutionComponent;
    if (resolution !== HOURLY && dayDiff > 7) {
      let className = classnames('link', { selected: resolution === WEEKLY });
      weeklyResolutionComponent = (
        <span className={className} onClick={this.onResoulationChange.bind(this, WEEKLY)}>
          Week
        </span>
      );
    }

    var monthlyResolutionComponent;
    if (resolution !== HOURLY && dayDiff > 30) {
      let className = classnames('link', { selected: resolution === MONTHLY });
      monthlyResolutionComponent = (
        <span className={className} onClick={this.onResoulationChange.bind(this, MONTHLY)}>
          Month
        </span>
      );
    }
    return (
      <div className="graph-header">
        <span className="graph-title">{title}</span>
        <div className="resolution-container">
          {hourlyResolutionComponent}
          {showHourly && showDaily && resolutionBorderComponent}
          {dailyResolutionComponent}
          {showDaily && showWeekly && resolutionBorderComponent}
          {weeklyResolutionComponent}
          {showWeekly && showMonthly && resolutionBorderComponent}
          {monthlyResolutionComponent}
        </div>
      </div>
    );
  }
}

GraphHeader.displayName = 'GraphHeader';

GraphHeader.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  resolutionChange: PropTypes.func.isRequired,
  hasHourly: PropTypes.bool,
  items: PropTypes.array,
  resolution: PropTypes.string
};

GraphHeader.defaultProps = {
  items: [],
  resolution: DAILY
};

export default GraphHeader;
